/**
 * Component to synchronize language preferences between i18next and Supabase
 */

import { useLanguageSync } from '@/hooks/use-language-sync';

export const LanguageSync = () => {
  useLanguageSync();
  return null;
};
